import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import MainMenu from '../components/MainMenu';
import BecomeMemberPage from './BecomeMemberPage';
import { finalizarAtendimento as finalizarAtendimentoApi } from '../api/finalizarAtendimento';

const MenuPage = () => {
  const navigate = useNavigate();
  const { currentUser, isMensalista, isAdmin, logoutUser, atendimentoId, setAtendimentoId } = useApp();
  const [showBecomeMember, setShowBecomeMember] = useState(false);

  // Redirecionar para a página inicial se não houver usuário logado
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  // Função para encerrar o atendimento (finaliza a sessão no banco de dados)
  const handleFinalizarAtendimento = async () => {
    if (!atendimentoId) return;
    try {
      await finalizarAtendimentoApi(atendimentoId);
    } catch (error) {
      console.error('Erro ao finalizar atendimento:', error);
    }
    setAtendimentoId(null);
    logoutUser();
    navigate('/');
  };

  // Função para apenas fazer logout sem encerrar o atendimento
  const handleLogout = () => {
    logoutUser();
    navigate('/');
  };

  // Função para navegar para a página de se tornar sócio
  const handleBecomeMember = () => {
    setShowBecomeMember(true);
  };

  // Função para voltar do formulário de se tornar sócio
  const handleBackFromBecomeMember = () => {
    setShowBecomeMember(false);
  };

  // Renderizar a página de se tornar sócio ou o menu principal
  if (showBecomeMember) {
    return (
      <BecomeMemberPage 
        userData={currentUser} 
        onBack={handleBackFromBecomeMember} 
      />
    );
  }

  return (
    <MainMenu
      userName={currentUser?.name || 'Visitante'}
      isMensalista={isMensalista}
      isAdmin={isAdmin}
      onLogout={handleLogout}
      onFinalizarAtendimento={handleFinalizarAtendimento}
      onBecomeMember={handleBecomeMember}
    />
  );
};

export default MenuPage;
